import PropTypes from 'prop-types';
import React from 'react';

import { theme } from 'src/styles/theme';

const SortingArrows = ({ sortDirection }) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M4 10L8 14L12 10H4Z"
      fill={sortDirection === 'asc' ? theme.palette.common.gray800 : theme.palette.common.gray500}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12 6L8 2L4 6L12 6Z"
      fill={sortDirection === 'desc' ? theme.palette.common.gray800 : theme.palette.common.gray500}
      fillRule="evenodd"
    />
  </svg>
);

SortingArrows.propTypes = {
  sortDirection: PropTypes.oneOf(['asc', 'desc']),
};

export default SortingArrows;
